import store from '@/state/store'

const hasAccessAll = store.getters['identity/hasAccessAll']
const hasTmsUserGroupAccess = hasAccessAll(['tms-user-group:read'])

const getFields = (self) => [
  {
    label: self.$t('routeOptimization.fields.number'),
    key: 'number',
    isRedirectable: true,
  },
  {
    label: self.$t('routeOptimization.fields.status'),
    key: 'status',
  },
  {
    label: self.$t('routeOptimization.fields.createdFO'),
    key: 'fleet_task_created',
  },
  {
    label: self.$t('routeOptimization.fields.createdOn'),
    key: 'created_on',
  },
  {
    label: self.$t('global.field.userGroup'),
    key: 'user_group.name',
    isShow: hasTmsUserGroupAccess,
  },
  {
    label: self.$t('routeOptimization.fields.createdBy'),
    key: 'created_by',
  },
  {
    label: self.$t('routeOptimization.fields.origin'),
    key: 'start_address.name',
  },
  {
    label: self.$t('routeOptimization.fields.departureTime'),
    key: 'expected_departure_on',
  },
  {
    label: self.$t('routeOptimization.fields.totalVehicle'),
    key: 'vehicle_count',
  },
]

export default getFields
